import { fetchOrders } from "actions/balance";
import { ORDERS_PAGE_SIZE } from "constants/util";
import RequireData from "hooks/RequireData";
import SagePaginationButton from "kit/SagePaginationButton";
import React from "react";
import ordersSelector from "selectors/orders";
import ordersStatusSelector from "selectors/ordersStatus";
import styles from "./BalanceMinutesOrdersRecordPage.module.scss";
import BalanceMinutesOrdersRecordRow from "./BalanceMinutesOrdersRecordRow";

interface Props {
    page: number;
    increment: () => void;
    decrement: () => void;
}

const BalanceMinutesOrdersRecordPage: React.FC<Props> = ({
    page,
    increment,
    decrement,
}) => {
    const [orders, status] = RequireData(
        ordersSelector(page),
        ordersStatusSelector(page),
        fetchOrders(page)
    );

    if (status === "error") {
        return (
            <div>
                <p className="text-danger">
                    Error occurred. Please reload to try again.
                </p>
            </div>
        );
    }

    if (status === "loading" || orders === undefined) {
        return (
            <div>
                <p>Loading...</p>
            </div>
        );
    }

    return (
        <div className="row align-items-start">
            <div className="col">
                {orders.map((o) => (
                    <BalanceMinutesOrdersRecordRow key={o.id} order={o} />
                ))}
                <SagePaginationButton
                    className={styles.buttonGroup}
                    incrementPage={increment}
                    decrementPage={decrement}
                    page={page}
                    canGoNext={orders && orders.length >= ORDERS_PAGE_SIZE}
                />
            </div>
        </div>
    );
};

export default BalanceMinutesOrdersRecordPage;
